import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ProtoDpadNavigationModule } from './lib/proto-dpad-navigation/proto-dpad-navigation.module';
import { BlankComponent } from './pages/blank/blank.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { LoginComponent } from './pages/login/login.component';
import { GenericModalComponent } from './components/generic-modal/generic-modal.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TokenInterceptorService } from './services/interceptors/token-interceptor.service';
import { EnvironmentService } from './services/environment.service';
import { SearchComponent } from './pages/search/search.component';
import { HomeComponent } from './pages/home/home.component';
import { ChannelSliderComponent } from './components/channel-slider/channel-slider.component';
import { HeroImageSliderComponent } from './components/hero-image-slider/hero-image-slider.component';
import { ImageSliderSmartTvComponent } from './components/image-slider-smart-tv/image-slider-smart-tv.component';
import { ChannelHeaderComponent } from './components/channel-header/channel-header.component';
import { ContinueWatchingComponent } from './components/continue-watching/continue-watching.component';
import { SeasonBannerComponent } from './components/season-banner/season-banner.component';
import { UserRecommendationsComponent } from './components/user-recommendations/user-recommendations.component';
import { VideoThumbComponent } from './components/video-thumb/video-thumb.component';
import { ShowThumbComponent } from './components/show-thumb/show-thumb.component';
import { HeroCarouselBannerSmartTvComponent } from './components/hero-carousel-banner-smart-tv/hero-carousel-banner-smart-tv.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { VideoComponent } from './pages/video/video.component';
import { ShakaPlayerComponent } from './components/shaka-player/shaka-player.component';
import { ShowsComponent } from './pages/shows/shows.component';
import { ShowDetailsComponent } from './pages/show-details/show-details.component';
import { ShowDetailsBannerComponent } from './components/show-details-banner/show-details-banner.component';
import { VideoThumbShowDetailsComponent } from './components/video-thumb-show-details/video-thumb-show-details.component';
import { SettingsPageComponent } from './pages/settings-page/settings-page.component';
import { MarkdownModule } from 'ngx-markdown';
import { VideoThumbSearchComponent } from './components/video-thumb-search/video-thumb-search.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { ReportMediaModalComponent } from './components/report-media-modal/report-media-modal.component';
import { WatchlistComponent } from './pages/watchlist/watchlist.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { LazyLoadDirective } from './directives/lazy-load.directive';
import { VideoThumbWatchlistComponent } from './components/video-thumb-watchlist/video-thumb-watchlist.component';
import { VideoThumbSharedComponent } from './components/video-thumb-shared/video-thumb-shared.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { LiveComponent } from './pages/live/live.component';
import { VideojsLiveComponent } from './components/videojs-live/videojs-live.component';
import { IvsLiveComponent } from './components/ivs-live/ivs-live.component';
import { RemoteConfigService } from './services/remote-config.service';
import { TranslatePipe } from './pipes/translate.pipe';
import { SpecialShowDetailsComponent } from './pages/special-show-details/special-show-details.component';
import { BrowseComponent } from './pages/browse/browse.component';
import { VideoThumbOpenComponent } from './components/video-thumb-open/video-thumb-open.component';
import { CreatorProfileComponent } from './pages/creator-profile/creator-profile.component';
import { HeroBannerStaticImageComponent } from './components/hero-banner-static-image/hero-banner-static-image.component';
import { FollowBtnComponent } from './components/follow-btn/follow-btn.component';
import { VideoThumbV2Component } from './components/video-thumb-v2/video-thumb-v2.component';
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
    declarations: [
        AppComponent,
        LandingPageComponent,
        LoginComponent,
        SearchComponent,
        BlankComponent,
        GenericModalComponent,
        HomeComponent,
        ChannelSliderComponent,
        HeroImageSliderComponent,
        ImageSliderSmartTvComponent,
        ChannelHeaderComponent,
        ContinueWatchingComponent,
        SeasonBannerComponent,
        UserRecommendationsComponent,
        VideoThumbComponent,
        ShowThumbComponent,
        HeroCarouselBannerSmartTvComponent,
        SideBarComponent,
        VideoComponent,
        ShakaPlayerComponent,
        ShowsComponent,
        ShowDetailsComponent,
        ShowDetailsBannerComponent,
        VideoThumbShowDetailsComponent,
        SettingsPageComponent,
        SearchComponent,
        VideoThumbSearchComponent,
        ComingSoonComponent,
        WatchlistComponent,
        VideoThumbWatchlistComponent,
        ReportMediaModalComponent,
        ProgressBarComponent,
        LazyLoadDirective,
        VideoThumbSharedComponent,
        SpinnerComponent,
        LiveComponent,
        VideojsLiveComponent,
        IvsLiveComponent,
        TranslatePipe,
        SpecialShowDetailsComponent,
        BrowseComponent,
        VideoThumbOpenComponent,
        CreatorProfileComponent,
        HeroBannerStaticImageComponent,
        FollowBtnComponent,
        VideoThumbV2Component,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,

        ProtoDpadNavigationModule,
        MarkdownModule.forRoot(),
        QRCodeModule,
    ],
    providers: [
        {
            // Auth Header Interceptor
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true
        },
        {
            // App Config
            provide: APP_INITIALIZER,
            useFactory: (envService: EnvironmentService) => () => envService.init(),
            deps: [EnvironmentService],
            multi: true
        },
        {
            // App Config
            provide: APP_INITIALIZER,
            useFactory: (config: RemoteConfigService) => () => config.init(),
            deps: [RemoteConfigService],
            multi: true
        }],
    bootstrap: [AppComponent]
})
export class AppModule {
}
